import useDailyGameId from "app/game-data/useDailyGameId";
import useFetchGameData from "app/game-data/useFetchGameData";
import { GameDataContext } from "app/game-data/useGameData";
import usePreviewGameId from "app/game-data/usePreviewGameId";

export default function GameDataProvider(props: React.PropsWithChildren) {
  const dailyGameId = useDailyGameId();
  const previewGameId = usePreviewGameId();
  const { data } = useFetchGameData(previewGameId || dailyGameId);

  return <GameDataContext value={data}>{props.children}</GameDataContext>;
}
